import { usePagination } from '@hooks';

export interface Receipt {
  amount: number;
  areaName: string | null;
  createdAt: string;
  customerTransactionType:
    | 'BALANCE_RECOVERY'
    | 'FUND'
    | 'ADJUSTMENT'
    | 'DISPERSION'
    | 'ASSIGNMENT'
    | 'REASSIGNMENT';
  id: string;
  movementType: 'CREDIT' | 'DEBIT';
  sourceAccountNumber: string | null;
}

export interface PaginationMetadata {
  limit: number;
  totalCount: number;
  totalPages: number;
  currentPage: number;
  previousPage: number | null;
  nextPage: number | null;
  pageLength: number;
}

interface props {
  partnerId: number;
  params: object;
  setURLparams: () => void;
}

interface ReturnGetAllUserPaginated extends PaginationMetadata {
  page: Receipt[];
}

/** Get partner transactions paginated */
const useGetPartnerTransactions = ({ partnerId, params, setURLparams }: props) => {
  const url = partnerId ? `/v3/partner/transactions/found/${partnerId}` : false;
  const { data: paginatedData, ...props } = usePagination(url, {
    params,
    setURLparams,
    paramKeys: ['page', 'limit', 'fromDate', 'toDate'],
  });
  const data = paginatedData as ReturnGetAllUserPaginated | undefined;

  return { data, ...props };
};

export default useGetPartnerTransactions;
